/**
 * The Session Page V2 flag key shared by the offline cache and the barrel gates.
 *
 * Extracted from the two string literals the barrel's V2 gates used to carry so
 * the offline decision cache and the gates that read it name the same flag by
 * construction. `key` is a FROZEN EXTERNAL IDENTITY — Flagsmith targets the
 * flag by it, so renaming this is switching flags, never a refactor.
 *
 * A leaf module with no imports, matching the other extracted keys in this
 * directory (`problem-based-charting-flag`, `wav-writer-recovery-payload`): the
 * gates live in `index.ts`, which the cache module must not import.
 */
export const SESSION_PAGE_V2_FLAG_KEY = 'release-scribe-session-page-v2';
